import ApiHandler from '@/api/base'

class InstanceAdministratorsApiHandler extends ApiHandler {
  async getAdmins() {
    const { data } = await this.http.post('/getAllPluginAdmins')
    return data
  }

  async removeAdmin({ accountId = null } = {}) {
    const { data } = await this.http.post('/removeUserFromPluginAdmins', {
      accountId
    })
    return data
  }

  async addAdmin({ accountId = undefined } = {}) {
    const { data } = await this.http.post('/addUserToPluginAdmins', {
      accountId
    })
    return data
  }

  async updateAdminRole({ accountId, adminRoleId }) {
    const { data } = await this.http.put('/admin/role', {
      accountId,
      adminRoleId
    })
    return data
  }
}

export default InstanceAdministratorsApiHandler
